export const environment = {
  production: true,

  //Kingdom prod servers
  // baseUrlAdmin: "http://10.0.1.140:6003",
  // baseUrlHR: "http://10.0.1.140:6008",
  // baseUrlApplicant: 'http://10.0.1.140:6400',
  // baseUrlProcurement: "http://10.0.1.140:6005",
  // baseUrlSupplierManagement: "http://10.0.1.140:6009",
  // baseUrlFixedAssets: "http://10.0.1.140:6004",
  // baseUrlPrepayments: "http://10.0.1.140:8099",
  // baseUrlFinance: "http://10.0.1.140:6004",
  // baseUrlMiddleware: "http://10.0.1.140:6011",
  // clientUrlHR: "http://10.0.1.140:6008/administration",
  // selfServiceUrlHR: "http://10.0.1.140:6008/portal",

  //Kingdom test servers
  // baseUrlAdmin: "http://10.0.1.144:6003",
  // baseUrlHR: "http://10.0.1.144:6008", 
  // baseUrlApplicant: 'http://10.0.1.144:6400',
  // baseUrlProcurement: "http://10.0.1.144:6005",
  // baseUrlSupplierManagement: "http://10.0.1.144:6009",
  // baseUrlFixedAssets: "http://10.0.1.144:6004",
  // baseUrlPrepayments: "http://10.0.1.144:8099",
  // baseUrlFinance: "http://10.0.1.144:6004",
  // baseUrlMiddleware: "http://10.0.1.144:6011",
  // clientUrlHR: "http://10.0.1.144:6008/administration",
  // selfServiceUrlHR: "http://10.0.1.144:6008/portal",

//  Emtech test server
  baseUrlAdmin: "https://fidelityadminerp.emtechhouse.co.ke/backend",
  baseUrlHR: "https://fidelityadminerp.emtechhouse.co.ke/hr",
  baseUrlApplicant: "https://fidelityapplicantserp.emtechhouse.co.ke/backend",
  baseUrlProcurement: "https://fidelityadminerp.emtechhouse.co.ke/procurement",
  baseUrlBudget: "https://fidelityadminerp.emtechhouse.co.ke/procurement",
  baseUrlSupplierManagement: "https://fidelitysuppliererp.emtechhouse.co.ke/backend",
  baseUrlFixedAssets: "https://fidelityadminerp.emtechhouse.co.ke/procurement",
  baseUrlPrepayments: "http://172.16.0.5:8099",
  baseUrlFinance: "https://fidelityadminerp.emtechhouse.co.ke/finance",
  baseUrlMiddleware: "http://172.16.0.5:9191",
  clientUrlHR: "http://172.16.0.5:6301/administration",
  selfServiceUrlHR: "http://172.16.0.5:6301/portal",

  //Localhost
  // baseUrlAdmin: "http://172.16.0.5:6200",
  // baseUrlHR: "http://localhost:6300",
  // baseUrlApplicant: "http://172.16.0.5:6400",
  // baseUrlProcurement: "http://172.16.0.5:9090",
  // baseUrlBudget: "http://172.16.0.5:9090",
  // baseUrlSupplierManagement: "http://172.16.0.5:1905",
  // baseUrlFixedAssets: "http://172.16.0.5:9090",
  // baseUrlPrepayments: "http://172.16.0.5:8099",
  // baseUrlFinance: "http://172.16.0.5:8199",
  // baseUrlMiddleware: "http://172.16.0.5:9191",
  // clientUrlHR: "http://172.16.0.5:6301/administration",
  // selfServiceUrlHR: "http://172.16.0.5:6301/portal",
};
